import { buildSelector } from '@/shared/lib/store';

export const [useGetTradingPlatformSessionCurrency] = buildSelector(
    (state) => state.tradingPlatformSession.currency,
);
